import Records from "@/services/records";
import InvoiceItemService from "@/services/invoice/invoice-item";

export default {
    data() {
        return {
            data: {
                patient: {
                    ci_url: null
                },
                treatment_vitals: null,
                complete_at: null,
                treatment_activity_type_id: null,
                isLab: false
            },
            prepareActivityDetails: false,
            staff: null,
            route: null,
            location: null,
            note: null,
            vitals: [],
            records: [],
            results: [],
            vitalNote: null
        };
    },
    computed: {},
    methods: {
        getActivity(id) {
            return this.$http
                .get(process.env.BARRACUDA + "schedule/activity/" + id)
                .then(response => {
                    if (
                        response &&
                        response.data &&
                        response.data.response &&
                        response.data.response.resources
                    ) {
                        return response.data.response.resources;
                    }
                });
        },
        openModal(activity, isOpenFromSoap = false) {
            switch (activity.generalStatus) {
                case "completed":
                    if (this._isTvView) {
                        return;
                    }
                    this.dialogs["summaryModal"].open({
                        ...activity,
                        patient: this.treatment.patient,
                        treatment: this.treatment,
                        isTreatmentboardNew: true,
                        isOpenFromSoap: isOpenFromSoap
                    });
                    break;
                default:
                    this.fill(activity);
            }
        },
        fill(activity, isOpenFromSoap = false) {
            if (this._isTvView) {
                return;
            }
            this.dialogShow(activity.id);
            switch (activity.treatment_activity_type_id) {
                case 1:
                    this.dialogs["createUpdateRecordModal"].open({
                        module: this.MODULE.TREATMENT_BOARD,
                        patient: this.treatment.patient,
                        staff: this.treatment.staffs,
                        clientID: this.treatment.client_id,
                        treatment: this.treatment,
                        activity: activity,
                        action: "new",
                        isTreatmentboardNew: true,
                        isOpenFromSoap: isOpenFromSoap,
                        soapId: this.treatment.soap_id || null
                    });
                    break;
                case 2:
                    this.dialogs["newVitalModal"].open({
                        patient: this.treatment.patient,
                        staff: this.treatment.staffs,
                        client: this.treatment.clients,
                        treatment: this.treatment,
                        activity: activity,
                        isTreatmentboardNew: true,
                        isOpenFromSoap: isOpenFromSoap
                    });
                    break;
                case 3:
                    this.dialogs["startTaskModal"].open({
                        activity: activity,
                        patient: this.treatment.patient,
                        treatment: this.treatment,
                        isTreatmentboardNew: true,
                        isOpenFromSoap: isOpenFromSoap
                    });
                    break;
                default:
                    console.error("Undefined activity type");
            }
            this.dialogHidden();
        },
        dialogShow(id) {
            this.$root.$once("bv::modal::shown", modal => {
                modal.vueTarget.activity_id = id;
                modal.vueTarget.treatment_id = this.treatment.id;

                let params = {
                    id,
                    time: this._now(),
                    staff: this.$root.currentActor,
                    treatment_id: this.treatment.id
                };

                this.$socket.client.emit("v-broadcast", {
                    params,
                    action: "activity-lock",
                    businessId: this._setting.business_id
                });
                this.$store.commit("locked_activity", params);
                window.addEventListener("beforeunload", this.activityUnlock);
            });
        },
        dialogHidden() {
            this.$root.$once("bv::modal::hide", this.activityUnlock);
        },
        activityUnlock(modal) {
            this.$socket.client.emit("v-broadcast", {
                params: {
                    id: modal.vueTarget.activity_id,
                    time: this._now(),
                    staff: this.$root.currentActor,
                    treatment_id: this.treatment.id
                },
                action: "activity-unlock",
                businessId: this._setting.business_id
            });
            this.$store.commit("locked_activity", null);
            window.removeEventListener("beforeunload", this.activityUnlock);
        },
        async edit(data, isOpenFromSoap = false) {
            // Merge initial data
            this.treatment = data.treatment;
            let activity = data.activity;

            if (this._isTvView) {
                return;
            }
            this.dialogShow(activity.id);
            if (activity.status === 1) {
                switch (activity.treatment_activity_type_id) {
                    case 1:
                        this.openMedicalRecordEdit(activity, isOpenFromSoap);
                        break;
                    case 2:
                        this.dialogs["newVitalModal"].open({
                            patient: this.treatment.patient,
                            staff: this.treatment.staffs,
                            client: this.treatment.clients,
                            treatment: this.treatment,
                            activity: activity,
                            action: "editRecord"
                        });
                        break;
                    case 3:
                        this.dialogs["startTaskModal"].open({
                            activity: activity,
                            patient: this.treatment.patient,
                            treatment: this.treatment,
                            action: "editRecord"
                        });
                        break;
                }
            } else {
                this.dialogs["editModal"].open({
                    ...activity,
                    action: activity.status === 3 ? "reactivate" : "edit",
                    patient: this.treatment.patient
                });
            }
            this.dialogHidden();
        },
        duplicate(data) {
            // Merge initial data
            this.treatment = data.treatment;
            let activity = data.activity;

            if (this._isTvView) {
                return;
            }
            this.dialogShow(activity.id);
            // Modify the properties in the activity object as default value
            activity.occurence = 1;
            activity.specific_interval = 15;
            activity.repeat_interval = "minutes";
            activity.due_type = 2;

            this.dialogs["editModal"].open({
                ...activity,
                action: "duplicate",
                patient: this.treatment.patient
            });
        },
        deleteModal(data) {
            // Merge initial data
            this.treatment = data.treatment;
            let activity = data.activity;

            this.dialogShow(activity.id);
            this.dialogs["deleteActivityModal"].open(
                activity,
                this.treatment.patient
            );
            this.dialogHidden();
        },
        activityHistory(data) {
            // Merge initial data
            this.treatment = data.treatment;
            let activity = data.activity;

            this.dialogs["modalActivityHistory"].open({
                ...activity,
                activity: activity
            });
        },
        /**
         * @method openMedicalRecordEdit
         * @description Open modal edit medical record on treatment board activity once completed
         * handle in a method to avoid lexical declaration in case block (no-case-declarations)
         */
        async openMedicalRecordEdit(activity, isOpenFromSoap) {
            let editRecordDetails = {
                module: this.MODULE.TREATMENT_BOARD,
                patient: this.treatment.patient,
                staff: this.treatment.staffs,
                clientID: this.treatment.client_id,
                treatment: this.treatment,
                activity: activity,
                action: "edit",
                isOpenFromSoap: isOpenFromSoap,
                soapId: this.treatment.soap_id || null
            };

            const act = await this.getActivity(activity.id);

            if (act && act.medications) {
                // response act.medications return array of 1 object
                for (const medicalRecord of act.medications) {
                    const response = await Records.editRecordDetails(
                        medicalRecord.record_id
                    );
                    if (response) {
                        editRecordDetails.invoiceItemId =
                            response.form_data?.invoice_item_resource?.ID;
                        editRecordDetails.record_resources = response;
                        editRecordDetails.item_id =
                            response.form_data?.item_resource?.ID;
                    }
                }

                if (editRecordDetails.invoiceItemId) {
                    const invoiceItem = await InvoiceItemService.getInvoiceItem(
                        editRecordDetails.invoiceItemId
                    );
                    editRecordDetails.invoice_item = invoiceItem;
                }
            }

            this.dialogs["createUpdateRecordModal"].open(editRecordDetails);
        }
    }
};
